export const getFullName = (f, l) => {
  return f + (l ? " " + l : "");
};
